import React from "react";
import { Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from '@/styles/BlogForm.module.scss';


const BlogSkeleton = () => {
    return (
        <div className="box d-block text-decoration-none">
            <Row>
                <Col lg={8} className="first-col order-2 order-md-1">
                    <p>
                        <Skeleton width={120} height={20} />
                    </p>
                    <h4 className="mb-4">
                        <Skeleton width="80%" height={28} />
                    </h4>
                    <p className="normal-text mb-3">
                        <Skeleton count={3} />
                    </p>
                    <p className="d-block d-md-none read-time">
                        <Skeleton width={100} height={16} />
                    </p>
                    <div className="last-items">
                        <p>
                            <Skeleton width={60} height={20} />
                        </p>
                        <p className="mx-md-4">
                            <Skeleton width={80} height={20} />
                        </p>
                    </div>
                </Col>
                <Col className="last-col order-1 order-md-2">
                    <div
                        className="last-col-bg"
                        style={{
                            backgroundColor: "#e0e0e0",
                        }}
                    >
                        <Skeleton height={200} />
                    </div>
                </Col>
            </Row>
        </div>
    );
};

const SkeletonBlogList = ({ count = 3 }) => {
    return (
        <div className={styles.skeleton}>
            <div className="scale-container">
                <div className="casestudy-box pointer">
                    <div
                        className="bg-scale-img skeleton-loader"
                        style={{
                            backgroundImage: `linear-gradient(
                                                to right,
                                                #e0e0e0 25%,
                                                #f0f0f0 50%,
                                                #e0e0e0 75%
                                                )`,
                        }}
                    ></div>
                    <div className="text-content">
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <div>
                                <p className="h3 skeleton-text" style={{ width: "60%", height: "1.5rem" }}></p>
                                <p
                                    className="skeleton-text"
                                    style={{ width: "80%", height: "1rem", marginTop: "0.5rem" }}
                                ></p>
                            </div>
                            <div
                                className="skeleton-button"
                                style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "50%",
                                    background: "#e0e0e0",
                                }}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
            {Array.from({ length: count }).map((_, index) => (
                <BlogSkeleton key={index} />
            ))}
        </div>
    );
};

export default SkeletonBlogList;
